import actionTypes from 'constants/actionTypes'


export const changePrompt = (prompt: string) => {
  return {
    type: actionTypes.PROMPT.CHANGED,
    payload: {
      prompt
    }
  }
}
